import { render, staticRenderFns } from "./TruckDashboard.vue?vue&type=template&id=1ad3533f&scoped=true"
import script from "./TruckDashboard.vue?vue&type=script&lang=js"
export * from "./TruckDashboard.vue?vue&type=script&lang=js"
import style0 from "./TruckDashboard.vue?vue&type=style&index=0&id=1ad3533f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad3533f",
  null
  
)

export default component.exports